import { IApplicationState } from '../../types/redux';
import { selectKPNNewEntersExperimentActive } from '../experiments';
import { getIsCPL } from '../newbuilding';

export function isKPNRowVisible(state: IApplicationState) {
  const experimentActive = selectKPNNewEntersExperimentActive(state);

  return experimentActive && !getIsCPL(state);
}
